const MapMarker = () => {
  return <div className="ampMapMarker"></div>;
};

export default MapMarker;
